<template>
  <EnrollList :path="'/continueEdu'"></EnrollList>
</template>

<script>
  import EnrollList from '@/page/modules/enroll/list'
  export default {
    components: { EnrollList },
    data () {
      return {
      }
    }
  }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/page/continueEdu/enroll/list.vue